import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'locations',
            name: 'location',
            class: 'Modules\\Site\\Entities\\Location',


            loadedLight: false
        }
    }
}